module.exports = __webpack_public_path__ + "/images/cover-cta-caja-lila-m.212229c.jpg";